function reducer_User(state) {
    if (typeof state === 'undefined') {
        return {};
    }

    return state;
}

module.exports = reducer_User;
